var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 36C0.5 16.3939 16.3939 0.5 36 0.5C55.6061 0.5 71.5 16.3939 71.5 36C71.5 55.6061 55.6061 71.5 36 71.5C16.3939 71.5 0.5 55.6061 0.5 36Z",
    fill: "#FFBE1C",
    stroke: "#171111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3352 33.6664C49.1502 34.8501 49.1502 37.5085 47.3352 38.6922L31.6856 48.8979C29.6901 50.1993 27.0469 48.7674 27.0469 46.3851V25.9736C27.0469 23.5912 29.6901 22.1593 31.6856 23.4607L47.3352 33.6664Z",
    fill: "#171111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.e814ae2e7b33175a790dbf7395699133.svg";
export { ForwardRef as ReactComponent };